// extracted by mini-css-extract-plugin
module.exports = {"language":"ChangeLanguage_language__4DEum","popover":"ChangeLanguage_popover__6BHFs","languageItem":"ChangeLanguage_languageItem__zAYZv"};